import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MailX } from 'lucide-react';

const Unsubscribe = () => {
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | done | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(location.search.replace(/\+/g, '%2B'));
    const e = params.get('email');
    if (e) setEmail(e);
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/unsubscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setStatus('done');
        setMessage(data.message || 'You have been unsubscribed.');
      } else {
        setStatus('error');
        setMessage((data && data.detail) || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Failed to connect. Please try again later.');
    }
  };

  return (
    <div
      data-testid="unsubscribe-page"
      style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '100px 24px',
        backgroundColor: '#F4F1E8'
      }}
    >
      <div
        style={{
          maxWidth: '480px',
          width: '100%',
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
          padding: '48px 40px',
          textAlign: 'center',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.08)'
        }}
      >
        <MailX size={40} color="#111111" strokeWidth={1.5} style={{ marginBottom: '20px' }} />
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: '1.8rem',
            fontWeight: '700',
            color: '#111111',
            marginBottom: '12px'
          }}
        >
          Unsubscribe
        </h1>

        {status === 'done' ? (
          <div
            data-testid="unsubscribe-success"
            style={{
              padding: '16px',
              backgroundColor: '#F4F1E8',
              border: '1px solid #C9A24B',
              borderRadius: '4px',
              color: '#111111'
            }}
          >
            {message}
          </div>
        ) : (
          <>
            <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#6B6760', marginBottom: '28px' }}>
              Enter your email address below to stop receiving updates about The Goldilocks Zone.
            </p>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                data-testid="unsubscribe-email-input"
                style={{
                  width: '100%',
                  padding: '14px 16px',
                  border: '1px solid #E0E0E0',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  marginBottom: '16px',
                  boxSizing: 'border-box'
                }}
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                data-testid="unsubscribe-submit-button"
                style={{
                  width: '100%',
                  padding: '14px 24px',
                  backgroundColor: status === 'loading' ? '#999999' : '#111111',
                  color: '#F4F1E8',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: status === 'loading' ? 'not-allowed' : 'pointer'
                }}
              >
                {status === 'loading' ? 'Processing...' : 'Unsubscribe'}
              </button>
            </form>
            {status === 'error' && (
              <p data-testid="unsubscribe-error" style={{ marginTop: '16px', color: '#cc0000', fontSize: '0.9rem' }}>
                {message}
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
